import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import compact from 'lodash/compact';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';

// STYLE
import styles from './headerData.module.scss';

// MAIN COMPONENT
const HeaderData = ({ stockNo, year, make, model, onEditClick, disabled }) => {
  // MEMOS
  const details = useMemo(() => {
    return !!compact([year, make, model]).length;
  }, [make, model, year]);

  // RENDER
  return (
    <div className="d-flex align-items-center flex-wrap">
      {(stockNo || details) && (
        <div className={clsx('d-flex align-items-center mt-3', styles.container)}>
          <div className={styles.label}>
            <span className={styles.text}>
              STK# <span className={styles.stock}>{stockNo || '--'}</span>
              {details && ` | ${year || ''} ${make || ''} ${model || ''}`}
            </span>
          </div>
        </div>
      )}
      {onEditClick && (
        <Button.Link
          icon="edit"
          label="Edit"
          className="mt-3"
          onClick={onEditClick}
          disabled={disabled}
        />
      )}
    </div>
  );
};

// EXPORT
export default HeaderData;
